<template>
<div class="chapter">
<div class="inner_page">
<div class="ded">
<p class="ded"><strong>To Michael</strong></p>
<p class="center"><em>Le Paradis n’est pas artificiel</em>.</p>
<p class="center">—Ezra Pound</p>
<p class="figure"><img alt="" src="OEBPS/images/viii-1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?0928e9ba